import {createStore} from "vuex";

export const store = createStore({
    state: {
        stockData: null
    },
    getters: {},
    mutations: {
        setStockData(state, data) {
            state.stockData = data
        }
    },
    actions: {
    },
    modules: {}
});